(() => {
  function enhance(root) {
    root.querySelectorAll('.article-template__content table, #xcsub .tblsc table').forEach(table => {
      if (table.closest('.dc-readable-table-wrap')) return;
      const columns = Math.max(1, ...Array.from(table.rows, row =>
        Array.from(row.cells).reduce((count, cell) => count + cell.colSpan, 0)));
      const wrap = document.createElement('div');
      wrap.className = 'dc-readable-table-wrap';
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', table.caption?.textContent.trim() || 'Comparison table');
      wrap.style.setProperty('--dc-table-min', `${Math.max(480, columns * 160)}px`);
      table.before(wrap);
      wrap.append(table);
    });
    root.querySelectorAll('.card__heading a, .collection-hero__title').forEach(heading => {
      if (heading.dataset.dcWordBreaks) return;
      heading.dataset.dcWordBreaks = 'true';
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        if (!node.textContent.includes('/')) return;
        const parts = node.textContent.split('/');
        const fragment = document.createDocumentFragment();
        parts.forEach((part, index) => {
          fragment.append(document.createTextNode(part + (index < parts.length - 1 ? '/' : '')));
          if (index < parts.length - 1) fragment.append(document.createElement('wbr'));
        });
        node.replaceWith(fragment);
      });
    });
  }
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  // Collection facets replace the grid without a full page navigation.
  const grid = document.getElementById('ProductGridContainer');
  if (grid) new MutationObserver(() => enhance(grid)).observe(grid, {childList: true, subtree: true});
})();
